document.addEventListener('click', function(event){
  var qtyButton = event.target.closest('[data-qty-minus], [data-qty-plus]');
  if(!qtyButton) return;
  var wrapper = qtyButton.closest('.qty');
  if(!wrapper) return;
  var input = wrapper.querySelector('input');
  if(!input) return;
  var value = parseInt(input.value || '1', 10);
  if(qtyButton.matches('[data-qty-minus]')) value = Math.max(parseInt(input.min || '1', 10), value - 1);
  if(qtyButton.matches('[data-qty-plus]')) value = value + 1;
  input.value = value;
});

document.querySelectorAll('[data-hero-slider]').forEach(function(slider){
  var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-slide]'));
  var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-dot]'));
  if(slides.length < 2) return;
  var index = 0;
  var timer;

  function restartTextAnimation(slide){
    var items = Array.prototype.slice.call(slide.querySelectorAll('[data-hero-reveal]'));
    items.forEach(function(item, itemIndex){
      item.style.setProperty('--birgamo-hero-delay', (itemIndex * 90) + 'ms');
      item.classList.remove('birgamo-hero-reveal');
    });

    window.requestAnimationFrame(function(){
      window.requestAnimationFrame(function(){
        items.forEach(function(item){ item.classList.add('birgamo-hero-reveal'); });
      });
    });
  }

  function go(next){
    index = (next + slides.length) % slides.length;
    slides.forEach(function(slide, i){ slide.classList.toggle('is-active', i === index); });
    dots.forEach(function(dot, i){ dot.classList.toggle('is-active', i === index); });
    restartTextAnimation(slides[index]);
  }

  function start(){ timer = setInterval(function(){ go(index + 1); }, 5200); }
  function stop(){ if(timer) clearInterval(timer); timer = null; }

  dots.forEach(function(dot){
    dot.addEventListener('click', function(){
      stop();
      go(parseInt(dot.getAttribute('data-hero-dot'), 10));
      start();
    });
  });

  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);
  restartTextAnimation(slides[index]);
  start();
});

// Shared storefront utilities.
function birgamoMoney(cents){
  try{
    if(window.Shopify && Shopify.formatMoney){ return Shopify.formatMoney(cents); }
  }catch(e){}
  return (cents/100).toLocaleString(undefined,{style:'currency',currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'});
}
function birgamoEscape(text){
  return String(text || '').replace(/[&<>'"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c];});
}

// Native entrance animations (local, no external JS dependency).
(function(){
  function init(){
    var selectors = '.announcement:not(.announcement--marquee) span, .announcement--marquee .announcement__group:first-child .announcement__item, .site-logo, .nav-link, .header-action, .hero__numbers button';
    document.querySelectorAll(selectors).forEach(function(el, index){
      el.classList.add('birgamo-reveal', 'birgamo-reveal--immediate');
      el.style.setProperty('--birgamo-reveal-delay', (Math.min(index, 10) * 35) + 'ms');
    });

    var revealTargets = document.querySelectorAll('.product-card, .drop-panel, .feature-photo > *, .cat-card, .info-panel, .collection-tile, .archive-card, .crew-card');
    if(!('IntersectionObserver' in window)){
      revealTargets.forEach(function(el){ el.classList.add('birgamo-reveal', 'is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {rootMargin: '0px 0px -9% 0px', threshold: 0.06});

    revealTargets.forEach(function(el){
      el.classList.add('birgamo-reveal');
      observer.observe(el);
    });
  }
  if(document.readyState === 'complete') init(); else window.addEventListener('load', init);
})();

// Newsletter popup
(function(){
  var popup = document.querySelector('[data-newsletter-popup]');
  if(!popup) return;

  var key = 'birgamo_newsletter_popup_closed';

  function lockPage(){
    document.documentElement.classList.add('newsletter-open');
    document.body.classList.add('newsletter-open');
  }

  function unlockPage(){
    document.documentElement.classList.remove('newsletter-open');
    document.body.classList.remove('newsletter-open');
  }

  function closeNewsletter(){
    popup.hidden = true;
    popup.classList.remove('is-active', 'active', 'open');
    popup.setAttribute('aria-hidden', 'true');
    unlockPage();
    try{ localStorage.setItem(key, '1'); }catch(e){}
  }

  function openNewsletter(){
    try{ if(localStorage.getItem(key) === '1') return; }catch(e){}
    popup.hidden = false;
    popup.classList.add('is-active');
    popup.setAttribute('aria-hidden', 'false');
    lockPage();
  }

  popup.addEventListener('click', function(event){
    if(event.target.closest('[data-newsletter-close], [data-popup-close], .newsletter-popup__close, .newsletter-popup__skip')){
      event.preventDefault();
      closeNewsletter();
    }
  });

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape' && !popup.hidden) closeNewsletter();
  });

  var delay = parseInt(popup.getAttribute('data-delay') || '4000', 10);
  setTimeout(openNewsletter, delay);
})();
// Lightweight storefront assistant with editable quick answers
(function(){
  var chat = document.querySelector('[data-ai-chat]');
  if(!chat) return;
  var panel = chat.querySelector('.ai-chat__panel');
  var messages = chat.querySelector('[data-ai-chat-messages]');
  var input = chat.querySelector('[data-ai-chat-input]');
  function toggle(){ var open = panel.hidden; panel.hidden = !open; chat.classList.toggle('is-open', open); if(open && input) setTimeout(function(){ input.focus(); }, 50); }
  function add(text, type){
    var msg = document.createElement('div');
    msg.className = 'ai-msg ai-msg--' + type;
    msg.textContent = text;
    messages.appendChild(msg);
    messages.scrollTop = messages.scrollHeight;
  }
  chat.querySelectorAll('[data-ai-chat-toggle]').forEach(function(btn){ btn.addEventListener('click', toggle); });
  chat.querySelectorAll('[data-ai-question]').forEach(function(btn){
    btn.addEventListener('click', function(){ add(btn.getAttribute('data-ai-question'), 'user'); add(btn.getAttribute('data-ai-answer'), 'bot'); });
  });
  var form = chat.querySelector('[data-ai-chat-form]');
  if(form) form.addEventListener('submit', function(event){
    event.preventDefault();
    var value = (input.value || '').trim();
    if(!value) return;
    add(value, 'user');
    input.value = '';
    add('Thanks. For exact product, sizing, or order details, check the product page or contact support. You can also use the quick questions above.', 'bot');
  });
})();

// Customer review popup
(function(){
  var popup;
  var lastTrigger;

  function mountReviewPopup(root){
    var scope = root || document;
    var candidate = scope.matches && scope.matches('[data-review-popup]')
      ? scope
      : scope.querySelector && scope.querySelector('[data-review-popup]');

    if(!candidate) return;

    /*
      Portal the fixed popup directly under <body>. A popup left inside the
      reviews Shopify section is constrained by that section's stacking
      context, so product stripes/footer can paint above it regardless of a
      large child z-index.
    */
    if(candidate.parentElement !== document.body){
      document.body.appendChild(candidate);
    }
    popup = candidate;
  }

  function openReviewPopup(trigger){
    if(!popup) mountReviewPopup(document);
    if(!popup) return;
    lastTrigger = trigger || document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('review-popup-open');
    var closeButton = popup.querySelector('[data-review-popup-close]');
    if(closeButton) window.requestAnimationFrame(function(){ closeButton.focus(); });
  }

  function closeReviewPopup(){
    if(!popup) return;
    popup.hidden = true;
    document.documentElement.classList.remove('review-popup-open');
    if(lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  mountReviewPopup(document);

  document.addEventListener('click', function(event){
    var openButton = event.target.closest('[data-review-popup-open]');
    if(openButton){
      event.preventDefault();
      openReviewPopup(openButton);
      return;
    }
    if(event.target.closest('[data-review-popup-close]')){
      event.preventDefault();
      closeReviewPopup();
    }
  });

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape' && popup && !popup.hidden) closeReviewPopup();
  });

  document.addEventListener('shopify:section:load', function(event){
    mountReviewPopup(event.target);
  });
})();


// V21 countdown timers
(function(){
  function pad(n){ return String(n).padStart(2,'0'); }
  document.querySelectorAll('[data-countdown-section]').forEach(function(section){
    var target = new Date(section.getAttribute('data-target') || '').getTime();
    var d=section.querySelector('[data-days]'), h=section.querySelector('[data-hours]'), m=section.querySelector('[data-minutes]'), s=section.querySelector('[data-seconds]');
    if(!target || !d) return;
    function tick(){
      var diff = Math.max(0, target - Date.now());
      var days = Math.floor(diff/86400000); diff -= days*86400000;
      var hours = Math.floor(diff/3600000); diff -= hours*3600000;
      var mins = Math.floor(diff/60000); diff -= mins*60000;
      var secs = Math.floor(diff/1000);
      d.textContent = pad(days); h.textContent = pad(hours); m.textContent = pad(mins); s.textContent = pad(secs);
    }
    tick(); setInterval(tick, 1000);
  });
})();

// V21 size guide modal + sticky add to cart
(function(){
  var modal = document.querySelector('[data-size-guide-modal]');
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-size-guide-open]') && modal){ modal.hidden = false; document.documentElement.classList.add('size-guide-open'); }
    if(e.target.closest('[data-size-guide-close]') && modal){ modal.hidden = true; document.documentElement.classList.remove('size-guide-open'); }
    if(e.target.closest('[data-sticky-atc]')){
      var form = document.querySelector('.product-info form[action*="/cart/add"]');
      var btn = form && form.querySelector('button[type="submit"]:not([disabled])');
      if(btn) btn.click();
    }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && modal){ modal.hidden = true; document.documentElement.classList.remove('size-guide-open'); } });
})();

/* V33 native predictive search: products, collections, journal articles and pages. */
(function(){
  var root = document.querySelector('[data-ajax-search]');
  if(!root) return;

  var toggle = root.querySelector('[data-ajax-search-toggle]');
  var form = root.querySelector('[data-ajax-search-form]');
  var input = root.querySelector('[data-ajax-search-input]');
  var panel = root.querySelector('[data-ajax-search-panel]');
  var endpoint = root.getAttribute('data-predictive-search-url') || '/search/suggest';
  var timer = null;
  var controller = null;
  var requestId = 0;
  var initialPanelMarkup = panel ? panel.innerHTML : '';
  var siteHeader = root.closest('.site-header');

  function positionSearch(){
    if(!siteHeader) return;
    var bottom = Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom));
    root.style.setProperty('--birgamo-search-top', bottom + 'px');
  }

  function openSearch(){
    positionSearch();
    root.classList.add('is-open');
    document.documentElement.classList.add('birgamo-search-open');
    if(toggle){
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close search');
    }
    setTimeout(function(){ if(input) input.focus(); }, 30);
  }

  function closeSearch(){
    root.classList.remove('is-open');
    document.documentElement.classList.remove('birgamo-search-open');
    if(toggle){
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Search');
    }
  }

  function getImage(item){
    if(!item) return '';
    if(typeof item.image === 'string') return item.image;
    if(item.image && item.image.url) return item.image.url;
    if(typeof item.featured_image === 'string') return item.featured_image;
    if(item.featured_image && item.featured_image.url) return item.featured_image.url;
    return '';
  }

  function resourceMeta(item, type){
    if(type === 'product') return '';
    if(type === 'collection') return 'Collection';
    if(type === 'article') return item.blog_title || 'Journal';
    if(type === 'page') return 'Page';
    return '';
  }

  function resultCard(item, type){
    var image = getImage(item);
    var title = birgamoEscape(item.title || 'Untitled');
    var url = birgamoEscape(item.url || '#');
    var meta = birgamoEscape(resourceMeta(item, type));
    var price = type === 'product' ? birgamoEscape(item.price || item.price_min || '') : '';
    var metaMarkup = meta ? '<span class="ajax-search__type">'+meta+'</span>' : '';
    return '<a class="ajax-search__item" role="option" href="'+url+'">'
      + '<span class="ajax-search__image">'+(image ? '<img src="'+birgamoEscape(image)+'" alt="" loading="lazy">' : '')+'</span>'
      + '<span><span class="ajax-search__title">'+title+'</span>'+metaMarkup+'</span>'
      + (price ? '<span class="ajax-search__price">'+price+'</span>' : '<span class="ajax-search__arrow" aria-hidden="true">→</span>')
      + '</a>';
  }

  function resultGroup(title, items, type, limit){
    if(!items || !items.length) return '';
    return '<section class="ajax-search__group" aria-label="'+birgamoEscape(title)+'">'
      + '<p class="ajax-search__group-title">'+birgamoEscape(title)+'</p>'
      + items.slice(0, limit).map(function(item){ return resultCard(item, type); }).join('')
      + '</section>';
  }

  function renderResults(resources, query){
    var results = resources && resources.results ? resources.results : {};
    var products = results.products || [];
    var collections = results.collections || [];
    var articles = results.articles || [];
    var pages = results.pages || [];

    if(!query || query.length < 2){
      panel.innerHTML = initialPanelMarkup || '<div class="ajax-search__empty">Start typing to search.</div>';
      return;
    }

    var html = '';
    html += resultGroup('Products', products, 'product', 6);
    html += resultGroup('Collections', collections, 'collection', 3);
    if(articles.length || pages.length){
      html += '<section class="ajax-search__group" aria-label="Journal and pages">'
        + '<p class="ajax-search__group-title">Journal &amp; pages</p>'
        + articles.slice(0, 2).map(function(item){ return resultCard(item, 'article'); }).join('')
        + pages.slice(0, 2).map(function(item){ return resultCard(item, 'page'); }).join('')
        + '</section>';
    }

    if(!html){
      panel.innerHTML = '<div class="ajax-search__empty">No results found. Try a different word.</div>'
        + '<a class="ajax-search__view-all" href="'+(form ? birgamoEscape(form.action) : '/search')+'?q='+encodeURIComponent(query)+'"><span>Browse all results</span><span>→</span></a>';
      return;
    }

    html += '<a class="ajax-search__view-all" href="'+(form ? birgamoEscape(form.action) : '/search')+'?q='+encodeURIComponent(query)+'"><span>View all results</span><span>→</span></a>';
    panel.innerHTML = html;
  }

  function search(query){
    query = (query || '').trim();
    if(query.length < 2){
      renderResults(null, query);
      return;
    }

    if(controller) controller.abort();
    controller = new AbortController();
    var currentRequest = ++requestId;
    panel.innerHTML = '<div class="ajax-search__loading">Searching...</div>';

    var url = endpoint + '.json?q=' + encodeURIComponent(query)
      + '&resources[type]=product,collection,article,page'
      + '&resources[limit]=6'
      + '&resources[limit_scope]=each'
      + '&resources[options][unavailable_products]=last';

    fetch(url, {headers: {'Accept':'application/json'}, signal: controller.signal})
      .then(function(response){
        if(!response.ok) throw new Error('Predictive search request failed');
        return response.json();
      })
      .then(function(data){
        if(currentRequest === requestId) renderResults(data.resources, query);
      })
      .catch(function(error){
        if(error.name !== 'AbortError' && currentRequest === requestId){
          panel.innerHTML = '<div class="ajax-search__empty">Search is temporarily unavailable.</div>';
        }
      });
  }

  if(toggle){
    toggle.addEventListener('click', function(event){
      event.preventDefault();
      if(window.birgamoMenuClosedAt && (Date.now() - window.birgamoMenuClosedAt) < 400){
        event.stopPropagation();
        return;
      }
      root.classList.contains('is-open') ? closeSearch() : openSearch();
    });
  }

  if(input){
    input.addEventListener('input', function(){
      clearTimeout(timer);
      var value = input.value;
      timer = setTimeout(function(){ search(value); }, 180);
    });
    input.addEventListener('keydown', function(event){
      if(event.key === 'Escape') closeSearch();
    });
  }

  if(form){
    form.addEventListener('submit', function(){
      var q = input ? input.value.trim() : '';
      if(q) form.action = form.getAttribute('action') || '/search';
    });
  }

  document.addEventListener('click', function(event){
    if(!root.contains(event.target)) closeSearch();
  });

  window.addEventListener('resize', function(){
    if(root.classList.contains('is-open')) positionSearch();
  }, {passive:true});

  window.addEventListener('scroll', function(){
    if(root.classList.contains('is-open')) positionSearch();
  }, {passive:true});

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape') closeSearch();
  });
})();


/* V32 mobile menu robust open/close */
document.addEventListener('click', function(event){
  var openMenu = event.target.closest('[data-mobile-menu-open]');
  if(openMenu){
    event.preventDefault();
    document.documentElement.classList.add('mobile-menu-open');
    document.body.classList.add('mobile-menu-open');
    return;
  }

  var closeMenu = event.target.closest('[data-mobile-menu-close]');
  if(closeMenu){
    event.preventDefault();
    window.birgamoMenuClosedAt = Date.now();
    document.documentElement.classList.remove('mobile-menu-open');
    document.body.classList.remove('mobile-menu-open');
    return;
  }

  if(document.documentElement.classList.contains('mobile-menu-open')){
    var panel = document.querySelector('[data-mobile-menu-panel]');
    if(panel && !panel.contains(event.target) && !event.target.closest('[data-mobile-menu-open]')){
      document.documentElement.classList.remove('mobile-menu-open');
      document.body.classList.remove('mobile-menu-open');
    }
  }
});

document.addEventListener('keydown', function(event){
  if(event.key === 'Escape'){
    document.documentElement.classList.remove('mobile-menu-open');
    document.body.classList.remove('mobile-menu-open');
  }
});


/* v45.22 editorial mobile drawer accordions + duplicate utility actions */
(function(){
  function closeMobileMenu(){
    document.documentElement.classList.remove('mobile-menu-open');
    document.body.classList.remove('mobile-menu-open');
  }

  document.addEventListener('click', function(event){
    var submenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
    if(submenuToggle){
      event.preventDefault();
      var id = submenuToggle.getAttribute('aria-controls');
      var submenu = id ? document.getElementById(id) : submenuToggle.closest('.mobile-menu-item').querySelector('[data-mobile-submenu]');
      if(!submenu) return;
      var willOpen = submenuToggle.getAttribute('aria-expanded') !== 'true';

      var drawer = submenuToggle.closest('[data-mobile-menu-panel]');
      if(drawer && willOpen){
        drawer.querySelectorAll('[data-mobile-submenu-toggle][aria-expanded="true"]').forEach(function(other){
          if(other === submenuToggle) return;
          other.setAttribute('aria-expanded','false');
          var otherId = other.getAttribute('aria-controls');
          var otherMenu = otherId ? document.getElementById(otherId) : null;
          if(otherMenu) otherMenu.hidden = true;
          var otherIcon = other.querySelector('[data-mobile-submenu-icon]');
          if(otherIcon) otherIcon.textContent = '+';
        });
      }

      submenuToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      submenu.hidden = !willOpen;
      var icon = submenuToggle.querySelector('[data-mobile-submenu-icon]');
      if(icon) icon.textContent = willOpen ? '−' : '+';
      return;
    }

    var drawerSearch = event.target.closest('[data-mobile-drawer-search]');
    if(drawerSearch){
      event.preventDefault();
      closeMobileMenu();
      var searchToggle = document.querySelector('[data-ajax-search-toggle]');
      if(searchToggle){
        window.requestAnimationFrame(function(){ searchToggle.click(); });
      }
      return;
    }

    if(event.target.closest('.mobile-menu-panel__utility[data-cart-open]')){
      closeMobileMenu();
    }
  });
})();



/* V77 clean dropdown filters: close other dropdowns when one opens */
(function(){
  document.addEventListener('toggle', function(event){
    var current = event.target;
    if(!current.matches('.filter-dropdown') || !current.open) return;
    document.querySelectorAll('.filter-dropdown[open]').forEach(function(drop){
      if(drop !== current) drop.removeAttribute('open');
    });
  }, true);

  document.addEventListener('click', function(event){
    if(event.target.closest('.filter-dropdown')) return;
    document.querySelectorAll('.filter-dropdown[open]').forEach(function(drop){
      drop.removeAttribute('open');
    });
  });
})();




/* V96 cookie buttons hard-fix */
(function(){
  var keys = ['birgamo_cookie_consent_v1', 'birgamo_cookie_consent'];

  function setCookie(name, value){
    document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=15552000; Path=/; SameSite=Lax';
  }

  function getCookie(name){
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    return parts.length === 2 ? parts.pop().split(';').shift() : '';
  }

  function hasChoice(){
    try {
      for(var i=0;i<keys.length;i++){
        if(localStorage.getItem(keys[i])) return true;
      }
    } catch(e) {}
    return !!(getCookie(keys[0]) || getCookie(keys[1]));
  }

  function saveChoice(value){
    value = value || 'accepted';
    try {
      keys.forEach(function(k){ localStorage.setItem(k, value); });
    } catch(e) {}
    keys.forEach(function(k){ setCookie(k, value); });
  }

  function getBanners(){
    return document.querySelectorAll('[data-cookie-banner], .cookie-banner, .cookies-banner, .cookie-consent');
  }

  function hide(value){
    saveChoice(value);
    getBanners().forEach(function(banner){
      banner.hidden = true;
      banner.setAttribute('aria-hidden', 'true');
      banner.classList.remove('is-active', 'active', 'open');
      banner.style.display = 'none';
      banner.style.pointerEvents = 'none';
    });
    document.documentElement.classList.remove('cookie-open');
    document.body.classList.remove('cookie-open');
  }

  function showOrHide(){
    if(hasChoice()){
      getBanners().forEach(function(banner){
        banner.hidden = true;
        banner.setAttribute('aria-hidden', 'true');
        banner.style.display = 'none';
        banner.style.pointerEvents = 'none';
      });
      return;
    }
    getBanners().forEach(function(banner){
      banner.hidden = false;
      banner.removeAttribute('aria-hidden');
      banner.style.display = '';
      banner.style.pointerEvents = 'auto';
      banner.classList.add('is-active');
    });
    document.documentElement.classList.add('cookie-open');
    document.body.classList.add('cookie-open');
  }

  document.addEventListener('click', function(event){
    var target = event.target;
    var control = target && target.closest('[data-cookie-accept], [data-cookie-decline], [data-cookie-close], [data-cookie-banner] button, .cookie-banner button, .cookies-banner button, .cookie-consent button, [data-cookie-banner] a, .cookie-banner a');
    if(!control) return;
    var banner = control.closest('[data-cookie-banner], .cookie-banner, .cookies-banner, .cookie-consent');
    if(!banner) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var value = control.matches('[data-cookie-decline]') ? 'declined' : 'accepted';
    hide(value);
  }, true);

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', showOrHide);
  } else {
    showOrHide();
  }

  window.BirgamoCookieConsent = {
    accept: function(){ hide('accepted'); },
    decline: function(){ hide('declined'); },
    reset: function(){
      try { keys.forEach(function(k){ localStorage.removeItem(k); }); } catch(e) {}
      keys.forEach(function(k){ document.cookie = k + '=; Max-Age=0; Path=/; SameSite=Lax'; });
      showOrHide();
    }
  };
})();


/* V113 clean horizontal cart drawer controller */
(function(){
  function money(cents){
    try { if(window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents); } catch(e) {}
    return (cents / 100).toLocaleString(undefined, {style:'currency', currency:'USD'});
  }

  function escapeHtml(value){
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch];
    });
  }

  function drawer(){ return document.querySelector('[data-cart-drawer]'); }

  function openCart(){
    var d = drawer();
    if(d){
      d.classList.remove('cart-is-closing');
      d.setAttribute('aria-hidden','false');
    }
    document.documentElement.classList.remove('cart-is-closing');
    document.body.classList.remove('cart-is-closing');
    document.documentElement.classList.add('cart-open');
    document.body.classList.add('cart-open');
    fetchCart();
  }

  function closeCart(){
    var d = drawer();
    if(d){
      d.classList.add('cart-is-closing');
      d.setAttribute('aria-hidden','true');
    }
    document.documentElement.classList.add('cart-is-closing');
    document.body.classList.add('cart-is-closing');
    setTimeout(function(){
      document.documentElement.classList.remove('cart-open','cart-is-closing');
      document.body.classList.remove('cart-open','cart-is-closing');
      if(d) d.classList.remove('cart-is-closing');
    }, 280);
  }

  function updateCounts(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = '(' + cart.item_count + ')';
    });
  }

  function renderItems(cart){
    var body = document.querySelector('[data-cart-body]');
    if(!body) return;

    var oldItems = body.querySelector('.b-cart__items');
    var oldEmpty = body.querySelector('.b-cart__empty');

    if(cart.item_count === 0){
      if(oldItems) oldItems.remove();
      if(!oldEmpty){
        body.insertAdjacentHTML(
          'afterbegin',
          '<div class="b-cart__empty"><p>Your bag is empty.</p><a href="/collections/all">Start shopping →</a></div>'
        );
      }
      return;
    }

    if(oldEmpty) oldEmpty.remove();

    var html = '<div class="b-cart__items" data-cart-items>';
    cart.items.forEach(function(item,index){
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? escapeHtml(item.variant_title) + ' · '
        : '';

      html += '<article class="b-cart-item">';
      html += '<a class="b-cart-item__media" href="'+escapeHtml(item.url)+'">';
      html += item.image ? '<img src="'+escapeHtml(item.image)+'" loading="lazy" alt="'+escapeHtml(item.product_title)+'">' : '';
      html += '</a>';
      html += '<div class="b-cart-item__info">';
      html += '<a class="b-cart-item__title" href="'+escapeHtml(item.url)+'">'+escapeHtml(item.product_title)+'</a>';
      html += '<p class="b-cart-item__meta">'+variant+'Qty '+item.quantity+'</p>';
      html += '<p class="b-cart-item__price">'+money(item.final_line_price)+'</p>';
      html += '<button type="button" class="b-cart-item__remove" data-cart-remove-line="'+(index+1)+'">Remove</button>';
      html += '</div></article>';
    });
    html += '</div>';

    if(oldItems) oldItems.outerHTML = html;
    else body.insertAdjacentHTML('afterbegin', html);
  }

  function cartCategory(cart){
    var hasEyewear = false;
    var hasTshirts = false;
    (cart.items || []).forEach(function(item){
      var source = String(item.product_type || item.product_title || '').toLowerCase();
      if(source.indexOf('eyewear') > -1 || source.indexOf('sunglass') > -1 || source.indexOf('glasses') > -1 || source.indexOf('frame') > -1) hasEyewear = true;
      if(source.indexOf('t-shirt') > -1 || source.indexOf('tshirt') > -1 || source.indexOf('tee') > -1 || source.indexOf('apparel') > -1) hasTshirts = true;
    });
    if(hasEyewear) return 'eyewear';
    if(hasTshirts) return 'tshirts';
    return 'default';
  }

  function updateCartUpsell(cart){
    var root = document.querySelector('[data-cart-upsell]');
    if(!root) return;
    var preferred = cartCategory(cart);
    var activeGroup = root.querySelector('[data-cart-cross-sell-group="' + preferred + '"]');
    if(!activeGroup || !activeGroup.querySelector('.b-upsell-card')){
      activeGroup = root.querySelector('[data-cart-cross-sell-group="default"]');
    }
    root.querySelectorAll('[data-cart-cross-sell-group]').forEach(function(group){
      group.classList.toggle('is-active', group === activeGroup);
    });
  }

  function updateCart(cart){
    updateCounts(cart);
    renderItems(cart);
    updateCartUpsell(cart);
    var subtotal = document.querySelector('[data-cart-subtotal]');
    if(subtotal) subtotal.textContent = money(cart.items_subtotal_price);
  }

  function fetchCart(){
    return fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(updateCart)
      .catch(function(){});
  }

  function changeLine(line, quantity){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({line:line, quantity:quantity})
    }).then(function(r){ return r.json(); }).then(updateCart);
  }

  function addForm(form){
    var formData = new FormData(form);
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Accept':'application/json'},
      credentials:'same-origin',
      body:formData
    }).then(function(r){ return r.json(); }).then(fetchCart);
  }

  document.addEventListener('click', function(event){
    if(event.target.closest('[data-cart-open]')){
      event.preventDefault();
      openCart();
      return;
    }

    if(event.target.closest('[data-cart-close]')){
      event.preventDefault();
      closeCart();
      return;
    }

    var remove = event.target.closest('[data-cart-remove-line]');
    if(remove){
      event.preventDefault();
      changeLine(parseInt(remove.getAttribute('data-cart-remove-line'), 10), 0);
      return;
    }

    var tab = event.target.closest('[data-upsell-tab]');
    if(tab){
      event.preventDefault();

      var root = tab.closest('[data-cart-upsell]');
      var key = tab.getAttribute('data-upsell-tab');
      if(!root) return;

      root.querySelectorAll('[data-upsell-tab]').forEach(function(button){
        var isActive = button === tab;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      root.querySelectorAll('[data-upsell-panel]').forEach(function(panel){
        panel.classList.toggle('is-active', panel.getAttribute('data-upsell-panel') === key);
      });

      var rail = root.querySelector('.b-cart-upsell__panels');
      if(rail){
        rail.scrollLeft = 0;
        rail.scrollTop = 0;
      }
    }
  }, true);

  document.addEventListener('submit', function(event){
    var upsell = event.target.closest('[data-cart-upsell-add]');
    if(upsell){
      event.preventDefault();
      addForm(upsell);
      return;
    }

    var quickAdd = event.target.closest('[data-quick-add]');
    if(quickAdd){
      event.preventDefault();
      addForm(quickAdd).then(openCart);
      return;
    }

    var productForm = event.target.closest('[data-product-form]');
    if(productForm && (!event.submitter || event.submitter.matches('[data-product-submit]'))){
      event.preventDefault();
      addForm(productForm).then(openCart);
    }
  }, true);

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape') closeCart();
  });

  fetchCart();
})();


/* V20 product-card gallery controller — vertical-scroll safe, one-slide swipes, tap-through links. */
(function(){
  function getSlideCount(gallery){
    return gallery.querySelectorAll('[data-product-card-gallery-line]').length || gallery.querySelectorAll('.product-card__gallery-slide').length;
  }

  function getCurrentIndex(track, slideCount){
    var width = Math.max(1, track.clientWidth);
    return Math.max(0, Math.min(slideCount - 1, Math.round(track.scrollLeft / width)));
  }

  function updateIndicators(gallery, track){
    var lines = gallery.querySelectorAll('[data-product-card-gallery-line]');
    if(!lines.length) return;

    var index = getCurrentIndex(track, lines.length);
    lines.forEach(function(line, lineIndex){
      line.classList.toggle('is-active', lineIndex === index);
    });
  }

  function snapToIndex(gallery, track, index, behavior){
    var slideCount = getSlideCount(gallery);
    if(!slideCount) return;

    var targetIndex = Math.max(0, Math.min(slideCount - 1, index));
    track.scrollTo({
      left: targetIndex * track.clientWidth,
      behavior: behavior || 'smooth'
    });
  }

  function setupGallery(gallery){
    var track = gallery.querySelector('[data-product-card-gallery-track]');
    if(!track || track.scrollWidth <= track.clientWidth + 2) return;

    var pointerId = null;
    var pointerType = '';
    var startX = 0;
    var startY = 0;
    var startScrollLeft = 0;
    var startIndex = 0;
    var direction = '';
    var hasDragged = false;
    var suppressNextClick = false;
    var swipeThreshold = 28;

    function resetGesture(){
      pointerId = null;
      pointerType = '';
      direction = '';
      hasDragged = false;
      track.classList.remove('is-dragging');
    }

    function finishDrag(event){
      if(pointerId === null) return;

      var deltaX = event && typeof event.clientX === 'number' ? event.clientX - startX : 0;
      var slideCount = getSlideCount(gallery);
      var targetIndex = getCurrentIndex(track, slideCount);

      if(direction === 'horizontal'){
        if(deltaX <= -swipeThreshold){
          targetIndex = startIndex + 1;
        } else if(deltaX >= swipeThreshold){
          targetIndex = startIndex - 1;
        } else {
          targetIndex = startIndex;
        }
      }

      var wasHorizontal = direction === 'horizontal';
      // The gallery is wrapped in a product link. A genuine horizontal drag
      // changes one slide, while a normal tap remains a normal link click.
      suppressNextClick = wasHorizontal && hasDragged;

      if(pointerId !== null){
        try { track.releasePointerCapture(pointerId); } catch(e) {}
      }

      resetGesture();

      // A single intentional drag can only move to the adjacent image.
      // This overrides momentum that would otherwise skip several slides.
      if(wasHorizontal){
        window.requestAnimationFrame(function(){ snapToIndex(gallery, track, targetIndex); });
      }
      updateIndicators(gallery, track);
    }

    track.addEventListener('pointerdown', function(event){
      if(event.button !== undefined && event.button !== 0) return;
      // Touch/pen use the browser's native momentum scroller. The custom
      // pointer-capture drag is retained only for desktop mouse input.
      if((event.pointerType || 'mouse') !== 'mouse') return;

      pointerId = event.pointerId;
      pointerType = event.pointerType || 'mouse';
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = track.scrollLeft;
      startIndex = getCurrentIndex(track, getSlideCount(gallery));
      direction = '';
      hasDragged = false;

      try { track.setPointerCapture(pointerId); } catch(e) {}
    });

    track.addEventListener('pointermove', function(event){
      if(pointerId !== event.pointerId) return;

      var deltaX = event.clientX - startX;
      var deltaY = event.clientY - startY;

      if(!direction && (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6)){
        direction = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';

        // Give vertical gestures back to the page immediately.
        if(direction === 'vertical'){
          try { track.releasePointerCapture(pointerId); } catch(e) {}
          resetGesture();
          return;
        }

        track.classList.add('is-dragging');
      }

      if(direction !== 'horizontal') return;
      hasDragged = true;
      track.scrollLeft = startScrollLeft - deltaX;
    });

    track.addEventListener('pointerup', finishDrag);

    track.addEventListener('click', function(event){
      if(!suppressNextClick) return;
      suppressNextClick = false;
      event.preventDefault();
      event.stopPropagation();
    });

    track.addEventListener('pointercancel', function(){
      if(pointerId !== null){
        try { track.releasePointerCapture(pointerId); } catch(e) {}
      }
      resetGesture();
      updateIndicators(gallery, track);
    });
    track.addEventListener('lostpointercapture', function(){
      if(pointerId !== null) resetGesture();
    });

    track.addEventListener('scroll', function(){
      window.requestAnimationFrame(function(){ updateIndicators(gallery, track); });
    }, {passive:true});

    gallery.addEventListener('keydown', function(event){
      var currentIndex = getCurrentIndex(track, getSlideCount(gallery));
      if(event.key === 'ArrowRight'){
        event.preventDefault();
        snapToIndex(gallery, track, currentIndex + 1);
      }
      if(event.key === 'ArrowLeft'){
        event.preventDefault();
        snapToIndex(gallery, track, currentIndex - 1);
      }
    });

    updateIndicators(gallery, track);
  }

  function init(){
    document.querySelectorAll('[data-product-card-gallery]').forEach(setupGallery);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* V127 infinite announcement marquee controller */
(function(){
  function makeItemClone(item){
    var clone = item.cloneNode(true);
    clone.removeAttribute('data-shopify-editor-block');
    clone.removeAttribute('data-block-id');
    clone.removeAttribute('id');
    clone.removeAttribute('style');
    clone.setAttribute('aria-hidden', 'true');
    return clone;
  }

  function prepareMarquee(root){
    var viewport = root.querySelector('[data-announcement-viewport]');
    var track = root.querySelector('[data-announcement-marquee]');
    var source = root.querySelector('[data-announcement-group]');
    var mirror = root.querySelector('[data-announcement-clone]');

    if(!viewport || !track || !source || !mirror) return;

    var originalItems = Array.prototype.slice.call(source.querySelectorAll('.announcement__item'));
    if(!originalItems.length) return;

    // Restore the author-defined source items before measuring again.
    Array.prototype.slice.call(source.querySelectorAll('[data-announcement-generated]')).forEach(function(node){
      node.remove();
    });
    mirror.innerHTML = '';

    // The source lane must always be wider than the visible viewport.
    // Repeat its original messages until there is enough content for a seamless loop.
    var minimumLaneWidth = Math.max(viewport.clientWidth + 120, 420);
    var guard = 0;
    while(source.scrollWidth < minimumLaneWidth && guard < 24){
      originalItems.forEach(function(item){
        var clone = makeItemClone(item);
        clone.setAttribute('data-announcement-generated', 'true');
        source.appendChild(clone);
      });
      guard += 1;
    }

    Array.prototype.slice.call(source.children).forEach(function(node){
      mirror.appendChild(makeItemClone(node));
    });

    // Pixel-based travel distance equals exactly one entire lane.
    root.style.setProperty('--announcement-distance', Math.ceil(source.scrollWidth) + 'px');
    root.classList.add('is-ready');
  }

  function initAnnouncementMarquees(){
    var marquees = Array.prototype.slice.call(document.querySelectorAll('.announcement--marquee'));
    marquees.forEach(prepareMarquee);

    if('ResizeObserver' in window){
      marquees.forEach(function(root){
        var viewport = root.querySelector('[data-announcement-viewport]');
        if(!viewport || viewport.dataset.marqueeObserved) return;
        viewport.dataset.marqueeObserved = 'true';
        var timeout;
        new ResizeObserver(function(){
          window.clearTimeout(timeout);
          timeout = window.setTimeout(function(){ prepareMarquee(root); }, 80);
        }).observe(viewport);
      });
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAnnouncementMarquees);
  } else {
    initAnnouncementMarquees();
  }

  document.addEventListener('shopify:section:load', function(event){
    var section = event.target;
    if(section && section.querySelectorAll){
      Array.prototype.slice.call(section.querySelectorAll('.announcement--marquee')).forEach(prepareMarquee);
    }
  });
})();


/* V128 compact fixed header controller */
(function(){
  function initCompactFixedHeader(){
    var header = document.querySelector('.site-header.site-header--mega');
    if(!header || header.dataset.fixedHeaderReady === 'true') return;

    header.dataset.fixedHeaderReady = 'true';

    var spacer = document.createElement('div');
    spacer.className = 'site-header-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    header.parentNode.insertBefore(spacer, header);

    var triggerY = 0;
    var ticking = false;

    function headerHeight(){
      return Math.ceil(header.getBoundingClientRect().height || 0);
    }

    function setFixed(shouldFix){
      var isFixed = header.classList.contains('is-header-fixed');
      if(shouldFix === isFixed) return;

      if(shouldFix){
        spacer.style.height = headerHeight() + 'px';
        spacer.classList.add('is-active');
        header.classList.add('is-header-fixed');
      } else {
        header.classList.remove('is-header-fixed');
        spacer.classList.remove('is-active');
        spacer.style.height = '0px';
      }
    }

    function measureTrigger(){
      var wasFixed = header.classList.contains('is-header-fixed');
      if(wasFixed){
        header.classList.remove('is-header-fixed');
        spacer.classList.remove('is-active');
      }

      triggerY = Math.round(header.getBoundingClientRect().top + window.scrollY);

      if(wasFixed && window.scrollY >= triggerY){
        spacer.style.height = headerHeight() + 'px';
        spacer.classList.add('is-active');
        header.classList.add('is-header-fixed');
      }
    }

    function update(){
      var shouldFix = window.scrollY >= triggerY;
      setFixed(shouldFix);
      ticking = false;
    }

    function onScroll(){
      if(!ticking){
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    measureTrigger();
    update();

    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', function(){
      window.requestAnimationFrame(function(){
        measureTrigger();
        update();
      });
    }, {passive:true});

    window.addEventListener('load', function(){
      measureTrigger();
      update();
    }, {once:true});
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initCompactFixedHeader);
  } else {
    initCompactFixedHeader();
  }

  document.addEventListener('shopify:section:load', initCompactFixedHeader);
})();

/* Client-ready product recommendations */
(function(){document.querySelectorAll('[data-product-recommendations]').forEach(function(section){var url=section.getAttribute('data-url');if(!url)return;fetch(url,{headers:{'Accept':'text/html'}}).then(function(r){return r.text()}).then(function(markup){var doc=new DOMParser().parseFromString(markup,'text/html');var replacement=doc.querySelector('[data-product-recommendations]');if(replacement&&replacement.innerHTML.trim())section.innerHTML=replacement.innerHTML}).catch(function(){});});})();


/* V12.7 collection toolbar dropdown stacking and mobile positioning */
(function(){
  function closeOtherDropdowns(current){
    document.querySelectorAll('.collection-toolbar-row details.filter-dropdown[open]').forEach(function(item){
      if(item !== current) item.removeAttribute('open');
    });
  }

  function positionMobilePanel(details){
    var panel = details.querySelector('.filter-dropdown__panel');
    var summary = details.querySelector('summary');
    if(!panel || !summary || !window.matchMedia('(max-width: 749px)').matches) return;

    /* v45.20: the mobile collection accordion stays in document flow.
       Do not let the legacy fixed-panel controller reposition it on scroll. */
    var filterForm = details.closest('[data-collection-filter-form]');
    if(filterForm && filterForm.querySelector('[data-mobile-filter-toggle]')) return;

    var rect = summary.getBoundingClientRect();
    var panelWidth = Math.min(288, window.innerWidth - 24);
    var left = Math.min(Math.max(12, rect.left), Math.max(12, window.innerWidth - panelWidth - 12));
    var top = Math.min(rect.bottom + 6, Math.max(12, window.innerHeight - 170));

    panel.style.setProperty('--birgamo-dropdown-left', Math.round(left) + 'px');
    panel.style.setProperty('--birgamo-dropdown-top', Math.round(top) + 'px');
  }

  function setupDropdowns(root){
    var scope = root || document;
    scope.querySelectorAll('.collection-toolbar-row details.filter-dropdown').forEach(function(details){
      if(details.dataset.birgamoDropdownReady === 'true') return;
      details.dataset.birgamoDropdownReady = 'true';

      details.addEventListener('toggle', function(){
        if(details.open){
          closeOtherDropdowns(details);
          window.requestAnimationFrame(function(){ positionMobilePanel(details); });
        }
      });
    });
  }

  function closeOnOutsideClick(event){
    var openDropdown = document.querySelector('.collection-toolbar-row details.filter-dropdown[open]');
    if(openDropdown && !openDropdown.contains(event.target)){
      openDropdown.removeAttribute('open');
    }
  }

  function repositionOpenDropdown(){
    var openDropdown = document.querySelector('.collection-toolbar-row details.filter-dropdown[open]');
    if(openDropdown) positionMobilePanel(openDropdown);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setupDropdowns(document); });
  } else {
    setupDropdowns(document);
  }

  document.addEventListener('click', closeOnOutsideClick);
  window.addEventListener('resize', repositionOpenDropdown, {passive:true});
  window.addEventListener('scroll', repositionOpenDropdown, {passive:true});
  document.addEventListener('shopify:section:load', function(event){ setupDropdowns(event.target); });
})();


/* V15 product conversion interface: swatches, variant-aware purchasing, zoom and recently viewed products */
(function(){
  function parseVariants(root){
    var node = root.querySelector('[data-product-variants]');
    if(!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch(error) { return []; }
  }

  function initProductInterface(root){
    root = root || document.querySelector('[data-product-root]');
    if(!root || root.dataset.birgamoProductReady === 'true') return;
    root.dataset.birgamoProductReady = 'true';

    var form = root.querySelector('[data-product-form]') || root.querySelector('form[action*="/cart/add"]');
    var select = root.querySelector('[data-variant-id-select]');
    var price = root.querySelector('[data-product-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stock = root.querySelector('[data-product-stock-status]');
    var submit = root.querySelector('[data-product-submit]');
    var stickySubmit = document.querySelector('[data-sticky-atc]');
    var payment = root.querySelector('[data-product-dynamic-payment]');
    var backInStock = root.querySelector('[data-back-in-stock]');
    var backInStockVariant = root.querySelector('[data-back-in-stock-variant]');
    var backInStockTags = root.querySelector('[data-back-in-stock-tags]');
    var backInStockBody = root.querySelector('[data-back-in-stock-body]');
    var variants = parseVariants(root);
    var title = root.getAttribute('data-product-title') || 'this product';
    var threshold = parseInt(root.getAttribute('data-low-stock-threshold') || '5', 10);
    var labels = {
      inStock: root.getAttribute('data-in-stock-label') || 'IN STOCK · READY TO SHIP',
      lowStock: root.getAttribute('data-low-stock-label') || 'LIMITED STOCK · SECURE YOUR SIZE',
      soldOut: root.getAttribute('data-sold-out-label') || 'SOLD OUT · JOIN THE NEXT DROP'
    };

    function selectedValues(){
      var result = [];
      root.querySelectorAll('[data-variant-option]:checked').forEach(function(input){
        result[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
      });
      return result;
    }

    function findVariant(values){
      if(!variants.length) return null;
      for(var i = 0; i < variants.length; i++){
        var variant = variants[i];
        var match = true;
        for(var optionIndex = 0; optionIndex < values.length; optionIndex++){
          if(values[optionIndex] && variant.options[optionIndex] !== values[optionIndex]){
            match = false;
            break;
          }
        }
        if(match) return variant;
      }
      return null;
    }

    function optionForVariant(variant){
      if(!select || !variant) return null;
      for(var i = 0; i < select.options.length; i++){
        if(String(select.options[i].value) === String(variant.id)) return select.options[i];
      }
      return null;
    }

    function updateOptionStates(){
      if(!variants.length) return;
      var selected = selectedValues();
      root.querySelectorAll('[data-variant-option]').forEach(function(input){
        var position = parseInt(input.getAttribute('data-option-position'), 10) - 1;
        var candidate = selected.slice();
        candidate[position] = input.value;
        var exists = false;
        var available = false;

        variants.forEach(function(variant){
          var matches = true;
          for(var i = 0; i < candidate.length; i++){
            if(candidate[i] && variant.options[i] !== candidate[i]){
              matches = false;
              break;
            }
          }
          if(matches){
            exists = true;
            if(variant.available) available = true;
          }
        });

        input.disabled = !exists;
        var label = null;
        root.querySelectorAll('[data-variant-option-label]').forEach(function(candidateLabel){
          if(!label && candidateLabel.getAttribute('data-option-position') === String(position + 1) && candidateLabel.getAttribute('data-option-value') === input.value){
            label = candidateLabel;
          }
        });
        if(label){
          label.classList.toggle('is-unavailable', exists && !available);
          label.classList.toggle('is-disabled', !exists);
        }
      });
    }

    function syncSelection(variant){
      if(!variant) return;
      root.querySelectorAll('[data-variant-option]').forEach(function(input){
        var position = parseInt(input.getAttribute('data-option-position'), 10) - 1;
        input.checked = variant.options[position] === input.value;
      });
      root.querySelectorAll('[data-variant-option-current]').forEach(function(label){
        var position = parseInt(label.getAttribute('data-variant-option-current'), 10) - 1;
        label.textContent = variant.options[position] || '';
      });
    }

    function updateVariantUI(variant){
      if(!variant || !select) return;
      select.value = String(variant.id);
      var option = optionForVariant(variant);
      var variantPrice = option ? option.getAttribute('data-price') : '';
      var available = variant.available === true || (option && option.getAttribute('data-available') === 'true');
      var inventoryManaged = option && option.getAttribute('data-inventory-management') === 'true';
      var inventory = parseInt((option && option.getAttribute('data-inventory')) || '0', 10);
      var variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';

      if(price && variantPrice) price.textContent = variantPrice;
      if(stickyPrice && variantPrice) stickyPrice.textContent = variantPrice;

      if(submit){
        submit.disabled = !available;
        submit.textContent = available ? 'AJOUTER AU PANIER' : 'SOLD OUT';
      }
      if(stickySubmit){
        stickySubmit.disabled = !available;
        stickySubmit.textContent = available ? 'AJOUTER AU PANIER' : 'SOLD OUT';
      }
      if(payment) payment.hidden = !available;

      if(stock){
        stock.classList.remove('is-low');
        if(!available){
          stock.textContent = labels.soldOut;
        }else if(inventoryManaged && inventory > 0 && inventory <= threshold){
          stock.textContent = labels.lowStock;
          stock.classList.add('is-low');
        }else{
          stock.textContent = labels.inStock;
        }
      }

      if(backInStock){
        backInStock.hidden = available;
        if(backInStockVariant) backInStockVariant.textContent = variantTitle ? 'Request for ' + variantTitle : 'Request for this product';
        if(backInStockTags) backInStockTags.value = 'back in stock, ' + title + (variantTitle ? ', ' + variantTitle : '');
        if(backInStockBody) backInStockBody.value = 'Back in stock request for ' + title + (variantTitle ? ' — ' + variantTitle : '') + '.';
      }

      syncSelection(variant);
      updateOptionStates();
    }

    function selectFromInputs(event){
      var current = findVariant(selectedValues());
      if(!current && event && event.target){
        var position = parseInt(event.target.getAttribute('data-option-position'), 10) - 1;
        var value = event.target.value;
        var fallback = null;
        variants.some(function(variant){
          if(variant.options[position] === value && variant.available){ fallback = variant; return true; }
          return false;
        });
        if(!fallback){
          variants.some(function(variant){
            if(variant.options[position] === value){ fallback = variant; return true; }
            return false;
          });
        }
        current = fallback;
      }
      if(current) updateVariantUI(current);
    }

    root.querySelectorAll('[data-variant-option]').forEach(function(input){
      input.addEventListener('change', selectFromInputs);
    });

    if(select){
      select.addEventListener('change', function(){
        var id = this.value;
        var found = null;
        variants.some(function(variant){
          if(String(variant.id) === String(id)){ found = variant; return true; }
          return false;
        });
        if(found) updateVariantUI(found);
      });
    }

    var initialVariant = null;
    if(select && select.value){
      variants.some(function(variant){
        if(String(variant.id) === String(select.value)){ initialVariant = variant; return true; }
        return false;
      });
    }
    if(initialVariant) updateVariantUI(initialVariant);
  }

  function initProductMedia(root){
    root = root || document.querySelector('[data-product-root]');
    if(!root || root.dataset.birgamoMediaReady === 'true') return;
    var modal = document.querySelector('[data-product-media-modal]');
    if(!modal) return;
    root.dataset.birgamoMediaReady = 'true';

    var slides = Array.prototype.slice.call(modal.querySelectorAll('[data-product-media-slide]'));
    var count = modal.querySelector('[data-product-media-count]');
    var previousFocus = null;
    var activeIndex = 0;

    function setActive(index){
      if(!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach(function(slide, slideIndex){
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });
      if(count) count.textContent = (activeIndex + 1) + ' / ' + slides.length;
    }

    function open(index, trigger){
      previousFocus = trigger || document.activeElement;
      setActive(parseInt(index || '0', 10) || 0);
      modal.hidden = false;
      document.documentElement.classList.add('product-media-modal-open');
      var close = modal.querySelector('[data-product-media-close]');
      if(close) close.focus();
    }

    function close(){
      modal.hidden = true;
      document.documentElement.classList.remove('product-media-modal-open');
      if(previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    }

    root.querySelectorAll('[data-product-gallery-open]').forEach(function(trigger){
      trigger.addEventListener('click', function(){ open(trigger.getAttribute('data-product-gallery-index'), trigger); });
    });
    modal.querySelectorAll('[data-product-media-close]').forEach(function(button){ button.addEventListener('click', close); });
    var previous = modal.querySelector('[data-product-media-prev]');
    var next = modal.querySelector('[data-product-media-next]');
    if(previous) previous.addEventListener('click', function(){ setActive(activeIndex - 1); });
    if(next) next.addEventListener('click', function(){ setActive(activeIndex + 1); });
    document.addEventListener('keydown', function(event){
      if(modal.hidden) return;
      if(event.key === 'Escape') close();
      if(event.key === 'ArrowLeft') setActive(activeIndex - 1);
      if(event.key === 'ArrowRight') setActive(activeIndex + 1);
    });
  }

  function initRecentlyViewed(){
    var root = document.querySelector('[data-product-root][data-product-handle]');
    var section = document.querySelector('[data-recently-viewed]');
    var grid = document.querySelector('[data-recently-viewed-grid]');
    if(!root || !section || !grid) return;

    var handle = root.getAttribute('data-product-handle');
    if(!handle) return;

    var key = 'birgamo_recently_viewed_products';
    var history = [];
    try {
      history = JSON.parse(localStorage.getItem(key) || '[]');
      if(!Array.isArray(history)) history = [];
    } catch(error) {
      history = [];
    }

    var recent = history.filter(function(item){ return item && item !== handle; }).slice(0, 4);
    history = [handle].concat(recent).slice(0, 8);
    try { localStorage.setItem(key, JSON.stringify(history)); } catch(error) {}

    if(!recent.length) return;

    var rootUrl = '/';
    try {
      rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    } catch(error) {}

    Promise.all(recent.map(function(productHandle){
      return fetch(rootUrl.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(productHandle) + '.js')
        .then(function(response){ return response.ok ? response.json() : null; })
        .catch(function(){ return null; });
    })).then(function(products){
      products = products.filter(Boolean);
      if(!products.length) return;

      grid.innerHTML = products.map(function(item){
        var image = item.featured_image || '';
        var title = birgamoEscape(item.title || 'BIRGAMO PRODUCT');
        var href = birgamoEscape(item.url || (rootUrl + 'products/' + item.handle));
        var price = item.price ? birgamoMoney(item.price) : '';
        return '<a class="recently-viewed-card" href="' + href + '">'
          + '<span class="recently-viewed-card__media">' + (image ? '<img src="' + birgamoEscape(image) + '" alt="' + title + '" loading="lazy" width="720" height="850">' : '') + '</span>'
          + '<span class="recently-viewed-card__body"><strong>' + title + '</strong><span>' + birgamoEscape(price) + '</span></span>'
          + '</a>';
      }).join('');
      section.hidden = false;
    });
  }

  function boot(){
    initProductInterface();
    initProductMedia();
    initRecentlyViewed();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function(event){
    var root = event.target.querySelector && event.target.querySelector('[data-product-root]');
    if(root){
      initProductInterface(root);
      initProductMedia(root);
    }
  });
})();


/* V13 native collection filters: Shopify Search & Discovery form controls */
(function(){
  function submitFilterForm(form){
    if(!form) return;
    if(typeof form.requestSubmit === 'function'){
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function initCollectionFilters(root){
    var scope = root || document;
    scope.querySelectorAll('[data-collection-filter-form]').forEach(function(form){
      if(form.dataset.birgamoFiltersReady === 'true') return;
      form.dataset.birgamoFiltersReady = 'true';

      form.addEventListener('change', function(event){
        if(event.target && event.target.matches('[data-filter-auto-submit]')){
          submitFilterForm(form);
        }
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initCollectionFilters(document); });
  } else {
    initCollectionFilters(document);
  }

  document.addEventListener('shopify:section:load', function(event){
    initCollectionFilters(event.target);
  });
})();

/* Keep the selected sort order when a native filter chip is removed. */
(function(){
  document.addEventListener('click', function(event){
    var link = event.target.closest('[data-collection-filter-remove]');
    if(!link) return;

    var form = document.querySelector('[data-collection-filter-form]');
    var sortControl = form && form.querySelector('input[name="sort_by"]:checked');
    var sortBy = sortControl && sortControl.value;
    if(!sortBy) return;

    try {
      var url = new URL(link.href, window.location.origin);
      if(!url.searchParams.has('sort_by')){
        url.searchParams.set('sort_by', sortBy);
        link.href = url.pathname + (url.search || '') + (url.hash || '');
      }
    } catch(error) {}
  });
})();

/* BIRGAMO v45.20 — robust mobile collection filter controller.
   Uses explicit touch/click control for FILTER and SORT so the interface does
   not depend on browser-native <details> activation. Legacy mobile panel
   positioning is bypassed for this form. */
(function(){
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function setFilterPanelState(form, open){
    var toggle = form.querySelector('[data-mobile-filter-toggle]');
    form.classList.toggle('is-mobile-filters-open', open);
    if(toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

    if(!open){
      form.querySelectorAll('details.filter-dropdown:not(.filter-dropdown--sort)[open]').forEach(function(details){
        details.removeAttribute('open');
      });
    } else {
      setSortState(form, false);
    }
  }

  function setSortState(form, open){
    var sort = form.querySelector('details.filter-dropdown--sort');
    if(!sort) return;
    var summary = sort.querySelector('[data-mobile-sort-toggle], summary');
    if(open){
      form.classList.remove('is-mobile-filters-open');
      var filterToggle = form.querySelector('[data-mobile-filter-toggle]');
      if(filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
      form.querySelectorAll('details.filter-dropdown:not(.filter-dropdown--sort)[open]').forEach(function(details){
        details.removeAttribute('open');
      });
      sort.setAttribute('open', '');
    } else {
      sort.removeAttribute('open');
    }
    if(summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeMobileControls(form){
    setFilterPanelState(form, false);
    setSortState(form, false);
  }

  function handleMobileControl(event){
    if(!mobileQuery.matches) return;

    var filterToggle = event.target.closest('[data-mobile-filter-toggle]');
    if(filterToggle){
      var filterForm = filterToggle.closest('[data-collection-filter-form]');
      if(!filterForm) return;
      event.preventDefault();
      event.stopPropagation();
      setFilterPanelState(filterForm, !filterForm.classList.contains('is-mobile-filters-open'));
      return;
    }

    var sortToggle = event.target.closest('[data-mobile-sort-toggle]');
    if(sortToggle){
      var sort = sortToggle.closest('details.filter-dropdown--sort');
      var sortForm = sort && sort.closest('[data-collection-filter-form]');
      if(!sort || !sortForm) return;
      event.preventDefault();
      event.stopPropagation();
      setSortState(sortForm, !sort.open);
      return;
    }
  }

  /* Capture phase prevents older document-level dropdown handlers from
     competing with the dedicated mobile controls on Safari/iOS. */
  document.addEventListener('click', handleMobileControl, true);

  document.addEventListener('click', function(event){
    if(!mobileQuery.matches) return;
    document.querySelectorAll('[data-collection-filter-form]').forEach(function(form){
      if(form.contains(event.target)) return;
      closeMobileControls(form);
    });
  });

  document.addEventListener('keydown', function(event){
    if(event.key !== 'Escape' || !mobileQuery.matches) return;
    document.querySelectorAll('[data-collection-filter-form]').forEach(function(form){
      var wasOpen = form.classList.contains('is-mobile-filters-open') || !!form.querySelector('details.filter-dropdown--sort[open]');
      closeMobileControls(form);
      if(wasOpen){
        var toggle = form.querySelector('[data-mobile-filter-toggle]');
        if(toggle) toggle.focus();
      }
    });
  });

  function resetForViewport(){
    if(mobileQuery.matches) return;
    document.querySelectorAll('[data-collection-filter-form]').forEach(function(form){
      closeMobileControls(form);
    });
  }

  if(typeof mobileQuery.addEventListener === 'function'){
    mobileQuery.addEventListener('change', resetForViewport);
  } else if(typeof mobileQuery.addListener === 'function'){
    mobileQuery.addListener(resetForViewport);
  }
})();
